import React, { Component } from "react";
import { Field } from "redux-form";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchDropdown } from "../../../actions/actionCreators";

import {
  renderSearchMultipleDropdown,
  renderSearchDropDown
} from "../../common/form/FieldHelper";

class DeliveryTypeDropdown extends Component {
  render() {
    const {
      name,
      form,
      searchFn,
      onPostChange,
      multiple,
      preload = false,
      available_on_purchase,
      available_on_sale,
    } = this.props;

    return (
      <div className="field">
        <Field
          {...this.props}
          name={name}
          formId={form}
          searchFn={searchFn}
          dropdownType="delivery_type"
          type="delivery_type"
          valueField="id"
          component={
            multiple ? renderSearchMultipleDropdown : renderSearchDropDown
          }
          searchParams={{
            available_on_purchase,
            available_on_sale,
          }}
          onPostChange={onPostChange}
          preload={preload}
        />
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      searchFn: fetchDropdown
    },
    dispatch
  );
}

export default connect(null, mapDispatchToProps)(DeliveryTypeDropdown);
